import "@babel/polyfill";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import firebase from "firebase/app"; // firebase
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyARiQHEhCJGB_C0t02avws8NsCDKBsfkvI",
    authDomain: "art-masulso.firebaseapp.com",
    databaseURL: "https://art-masulso.firebaseio.com",
    projectId: "art-masulso",
    storageBucket: "art-masulso.appspot.com",
    messagingSenderId: "829042028692",
    appId: "1:829042028692:web:ede170ebd00982f42ac481",
    measurementId: "G-QV6NY01J6L",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.prototype.$firebase = firebase;
Vue.prototype.$db = firebase.firestore();
Vue.prototype.$storage = firebase.storage();

import anime from "animejs"; // anime
Vue.prototype.$anime = anime;

import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);

import VueYouTubeEmbed from "vue-youtube-embed";
Vue.use(VueYouTubeEmbed);
// if you don't want install the component globally
Vue.use(VueYouTubeEmbed, { global: false });

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
import "./assets/styles/index.scss";

// google map
import * as VueGoogleMaps from "vue2-google-maps";

// ie 브라우저 탐색
var isIE = /*@cc_on!@*/ false || !!document.documentMode;
if (isIE) {
    window.alert(
        "마을예술창작소는 크롬 혹은 웨일 브라우저에서 가장 원활한 사용이 가능합니다. 위 브라우저로 접속 부탁드립니다."
    );
    window.location.href = "https://www.google.co.kr/chrome/";
}

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyARiQHEhCJGB_C0t02avws8NsCDKBsfkvI",
        libraries: "places",
    },
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
